import {
  GET_NAVIGATION_SIDEBAR_SUCCESS,
  GET_NAVIGATION_SIDEBAR_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  navigations: [],
  error: {},
  loading: true,
}

const Navigation = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_NAVIGATION_SIDEBAR_SUCCESS:
      return {
        ...state,
        navigations: action.payload,
        loading: true,
      }
    case GET_NAVIGATION_SIDEBAR_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}

export default Navigation
